import { AxiosRequestConfig } from 'axios';
import { ActionContext } from 'vuex';

import { fetchSharedActivityTypes } from '@/shared/api/rest/RestApi';
import { ActivityType, ApiResponse } from '@/shared/api/rest/models';
import subscribableData from '@/shared/mixins/store/subscribableData/index';
import { SubscribableDataState } from '@/shared/mixins/store/types';
import { RootState } from '@/store/types';

export async function fetchAll(
  context: ActionContext<SubscribableDataState<ActivityType>, RootState>,
  axiosOptions?: AxiosRequestConfig,
): Promise<ApiResponse<ActivityType[]>> {
  const fieldSharingCompanyId = context.rootState.auth.currentCompanies?.[0]?.id;

  const { data } = await fetchSharedActivityTypes(fieldSharingCompanyId, axiosOptions);

  return data;
}

async function fetchByIds(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ids: string[],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  context: ActionContext<SubscribableDataState<ActivityType>, RootState>,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  axiosOptions?: AxiosRequestConfig,
): Promise<ApiResponse<ActivityType[]>> {
  throw new Error('NOT IMPLEMENTED');
}

export const subscribableStore = subscribableData(fetchAll, fetchByIds);
